import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
}), 'Crop54TwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Crop54TwoTone.js
// module id = 2998
// module chunks = 2